export const URGENT_CARE_PRIORITIES = [
  {
    title: 'Low',
    value: 'low',
    key: 'low'
  },
  {
    title: 'Medium',
    value: 'medium',
    key: 'medium'
  },
  {
    title: 'High',
    value: 'high',
    key: 'high'
  }
]

export const URGENT_CARE_STATUSES = [
  {
    title: 'New',
    label: 'New',
    value: 'new',
    key: 'new'
  },
  {
    title: 'Reviewed',
    label: 'Reviewed',
    value: 'reviewed',
    key: 'reviewed'
  },
  {
    title: 'Declined',
    label: 'Declined',
    value: 'declined',
    key: 'declined'
  },
  {
    title: 'Missed',
    label: 'Missed',
    value: 'missed',
    key: 'missed'
  },
  {
    title: 'Missed & Followed-up',
    label: 'Missed & Followed-up',
    value: 'missed and followed up',
    key: 'missed and followed up'
  },
  {
    title: 'Completed',
    label: 'Completed',
    value: 'completed',
    key: 'completed'
  }
]

export const URGENT_CARE_CALLBACK_CALL_TYPE = 'Urgent Care Call Back'

export const isUrgentCareCallbackCallType = (item = {}) =>
  item?.refValue === URGENT_CARE_CALLBACK_CALL_TYPE ||
  item?.title === URGENT_CARE_CALLBACK_CALL_TYPE

export const URGENT_CARE_TRIAGE_OUTCOME_SUBTYPES = [1, 2]

export const URGENT_CARE_DEFAULT_SORT = {
  sortedColumn: 'status',
  sortedColumnOrder: 'ascend'
}

export const URGENT_CARE_REPORT_DEFAULT_SORT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'ascend'
}
